import { LicenceTypeUpdateRequest } from "../types/Licences/LicenceTypeUpdateRequest";
import { LicenceTypeCreateRequest } from "../types/Licences/LicenceTypeCreateRequest";
import { AxiosInstance } from "axios";

export default class LicenceTypeAdminService {
  private _endpoint = "LicenceTypeAdmin";
  private _client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this._client = client;
  }

  public async GetLicenceSummaries(): Promise<any> {
    return this._client.get<any>(`${this._endpoint}`).then((response) => {
      return response.data;
    });
  }

  public async GetLicenceTypeById(id: string): Promise<any> {
    return this._client.get<any>(`${this._endpoint}/${id}`).then((response) => {
      return response.data;
    });
  }

  public async CreateLicenceType(
    licenceType: LicenceTypeCreateRequest,
  ): Promise<any> {
    return this._client
      .post<any>(`${this._endpoint}`, licenceType)
      .then((response) => {
        return response.data;
      });
  }

  public async UpdateLicenceType(
    licenceType: LicenceTypeUpdateRequest,
  ): Promise<any> {
    return this._client
      .patch<any>(`${this._endpoint}`, licenceType)
      .then((response) => {
        return response.data;
      });
  }

  public async DeleteLicenceType(id: number): Promise<any> {
    return this._client
      .delete<any>(`${this._endpoint}/${id}`)
      .then((response) => {
        return response.data;
      });
  }
}
